import { BillOfMaterialsItem } from "src/app/models/order-dto";

/**
 * Builds a CSV (Name, Quantity columns) from a bill of materials and triggers
 * a browser download.
 */
export function downloadBillOfMaterialsCsv(
  bom: BillOfMaterialsItem[],
  filename: string
): void {
  const header = "Name,Quantity";
  const rows = bom.map(
    (item) => `${escapeCsvValue(item.name ?? "")},${item.quantity ?? ""}`
  );
  const csv = [header, ...rows].join("\r\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const fileUrl = globalThis.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = filename;
  link.click();

  globalThis.URL.revokeObjectURL(fileUrl);
}

function escapeCsvValue(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}
